import React from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";
import { dashboardColors } from "./dashboardTheme";

const Sparkline = ({ color }) => (
  <Box sx={{ height: 52, width: "100%", mt: 0.5, opacity: 0.85 }}>
    <svg viewBox="0 0 200 52" preserveAspectRatio="none" width="100%" height="100%">
      <defs>
        <linearGradient id={`spark-${color.replace("#", "")}`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.35" />
          <stop offset="100%" stopColor={color} stopOpacity="0.02" />
        </linearGradient>
      </defs>
      <path
        d="M0,38 C20,32 35,42 55,28 S90,18 110,30 S145,40 165,22 S185,12 200,26 L200,52 L0,52 Z"
        fill={`url(#spark-${color.replace("#", "")})`}
      />
      <path
        d="M0,38 C20,32 35,42 55,28 S90,18 110,30 S145,40 165,22 S185,12 200,26"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeOpacity="0.55"
      />
    </svg>
  </Box>
);

const StatCard = ({ title, value, icon, color, isDark }) => {
  const colors = dashboardColors(isDark);

  return (
  <Card
    sx={{
      height: "100%",
      borderRadius: 3,
      border: isDark ? "1px solid rgba(148,163,184,0.12)" : "1px solid rgba(15,23,42,0.07)",
      boxShadow: isDark ? "0 2px 8px rgba(0,0,0,0.2)" : "0 1px 3px rgba(15,23,42,0.05)",
      bgcolor: isDark ? "#1e293b" : "#ffffff",
      overflow: "hidden",
      transition: "transform 0.2s ease, box-shadow 0.2s ease",
      "&:hover": {
        transform: "translateY(-2px)",
        boxShadow: isDark ? "0 8px 24px rgba(0,0,0,0.28)" : "0 8px 20px rgba(15,23,42,0.08)",
      },
    }}
  >
    <CardContent sx={{ pb: "12px !important", pt: 2.5, px: 2.5 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 1 }}>
        <Box sx={{ minWidth: 0 }}>
          <Typography
            variant="caption"
            sx={{
              fontWeight: 600,
              color: colors.textSoft,
              fontSize: "0.72rem",
              letterSpacing: "0.02em",
              display: "block",
              mb: 0.5,
            }}
          >
            {title}
          </Typography>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              lineHeight: 1.1,
              letterSpacing: "-0.02em",
              color: colors.text,
            }}
          >
            {value}
          </Typography>
        </Box>
        <Box
          sx={{
            width: 42,
            height: 42,
            borderRadius: 2,
            flexShrink: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: `${color}18`,
            color,
            "& svg": { fontSize: 22 },
          }}
        >
          {icon}
        </Box>
      </Box>
    </CardContent>
    <Sparkline color={color} />
  </Card>
  );
};

export default StatCard;
